import {NgModule} from '@angular/core';
import {LinkDirective} from './link/link.directive';

@NgModule({
  declarations: [LinkDirective],
  exports: [LinkDirective]
})
export class LinkModule {
}
